"use strict";

module.exports = function (accumulator, order, product, component) {
  var addition;

  if (component.place_card_style.toLowerCase() === 'flat') {
    if (!product.ink_colors.every(function (color) {
      return color.toLowerCase() === 'black';
    })) {
      addition = 'WAIT TO SHRINK - FULFILLMENT CHECK NEEDED\n\n* PULL SAMPLE CARD - CHECK FOR DEFECTS *';
    } else {
      addition = '* shrink all including blanks *';
    }
  } else {
    addition = 'DO NOT SHRINK - PUT IN BOX WITH LID';
  }

  if (accumulator.length && addition.length) {
    return "".concat(accumulator, "\n").concat(addition);
  }

  return "".concat(accumulator).concat(addition);
};